/** The sidebar controls affect the acting creature's d20, before net-stack clamps; damage and target saves are separate rolls. */
export function applyRawDiceModifiers(input: { rawDiceMod?: number; rawDiceAdvDisStacks?: number }, modifier = 0, stacks = 0): {
  modifier: number; stacks: number; manualStacks: number;
  sources: { kind: string; label: string; stacks: number }[];
  faces: [number, string][];
} {
  const rawMod = Number.isFinite(input.rawDiceMod) ? Math.trunc(input.rawDiceMod!) : 0;
  const manualStacks = Number.isFinite(input.rawDiceAdvDisStacks) ? Math.trunc(input.rawDiceAdvDisStacks!) : 0;
  return { modifier: modifier + rawMod, stacks: stacks + manualStacks, manualStacks,
    sources: manualStacks ? [{ kind: 'manual', label: 'Dice Modifier', stacks: manualStacks }] : [],
    faces: rawMod ? [[rawMod, 'Raw Mod']] : [] };
}
